import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-spinner',
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.css',
  standalone: true
})
export class SpinnerComponent {
  public isLoading: boolean = true;

  constructor() { }

  ngOnInit(): void {
    // Simulate a delay to show the spinner
    setTimeout(() => {
      this.isLoading = false;
    }, 3000); // Change this value to simulate loading time
  }

}
